import { 
  Users, 
  Calendar, 
  Award, 
  ClipboardCheck, 
  CheckSquare, 
  BookOpen, 
  BookMarked, 
  TrendingUp, 
  LogOut,
  HelpCircle
} from 'lucide-react';

interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export function Sidebar({ activeTab, setActiveTab }: SidebarProps) {
  const userRole = localStorage.getItem('uisce-user-role') || 'Trainer';

  const handleSignOut = () => {
    localStorage.removeItem('uisce-user-role');
    localStorage.removeItem('uisce-agent-id');
    window.location.reload();
  };

  const navItems = [
    { id: 'trainer-guide', label: 'Trainer Guide', icon: HelpCircle },
    { id: 'dashboard', label: 'Dashboard / Roster', icon: Users },
    { id: 'daily-progress', label: 'Daily Progress', icon: Calendar },
    { id: 'assessments', label: 'Assessments', icon: Award },
    { id: 'weekly-rag', label: 'Weekly RAG', icon: ClipboardCheck },
    { id: 'attendance', label: 'Attendance', icon: CheckSquare },
    { id: 'training-plan', label: 'Training Plan', icon: BookOpen },
    { id: 'courses', label: 'Mandatory Courses', icon: BookMarked },
    { id: 'hypercare', label: 'Hypercare', icon: TrendingUp },
  ];

  return (
    <aside className="w-64 bg-slate-900 text-slate-300 flex flex-col h-full shrink-0">
      <div className="p-6 border-b border-slate-800">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-primary-600 font-bold text-white flex items-center justify-center">
            UÉ
          </div>
          <div>
            <h1 className="font-bold text-white text-sm">Uisce Éireann</h1>
            <p className="text-xs text-slate-400">Onboarding Tracker</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`w-full flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-xs font-semibold transition-all cursor-pointer ${
                isActive
                  ? 'bg-primary-600 text-white shadow-sm'
                  : 'text-slate-400 hover:bg-slate-800 hover:text-slate-200'
              }`}
            >
              <Icon className="w-4 h-4" />
              {item.label}
            </button>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-800">
        <div className="p-3 bg-slate-800/60 rounded-xl mb-3">
          <div className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Access Level</div>
          <div className="text-xs font-bold text-slate-200 capitalize">{userRole}</div>
        </div>
        <button
          onClick={handleSignOut}
          className="w-full flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs font-bold text-red-400 hover:bg-red-500/10 transition-colors cursor-pointer"
        >
          <LogOut className="w-4 h-4" /> Sign Out
        </button>
      </div>
    </aside>
  );
}
